import { useToggle, useInterval } from 'react-use';
import React, { useEffect, useState } from 'react';
export const useCountdown = (timer, {
  onFinish
}) => {
  const [remain, setRemain] = useState(-1);
  useInterval(() => setRemain(remain - 1), remain ? 1000 : null);
  useEffect(() => {
    if (timer >= 0) {
      setRemain(timer);
    }
  }, [timer]);
  useEffect(() => {
    onFinish && remain === 0 && onFinish();
  }, [onFinish, remain]);
  return remain;
};
export default useCountdown;